module.exports = __webpack_public_path__ + "img/MTG-Logo.730d0196.jpg";